import {injectIntl} from "react-intl";
import connect from "react-redux/es/connect/connect";
import React, {Component} from "react";
import {List} from "antd";
import {SelectedService} from "../../definition/journeyModel";
import {isoDurationToMinutes} from "../../definition/helper";
import CheckboxServiceItem from "./CheckboxServiceItem";

class AdditionalServices extends Component {

  onCheckboxChange = (checked, item)=> {
    if (checked === true) {// unchecking the checkbox
      this.props.addService({
        selectedService:new SelectedService(
          item.name,
          item.title,
          isoDurationToMinutes(item.duration), //
          item.duration,
          item.price,
          item.description,
          item.moreInfo)
      });
    } else {
      this.props.removeService({name:item.name});
    }
  }

  hasOption = name => !!this.props.selectedOptions.find(o => o.id === name);

  render() {

    const {additionalServices, extraServices} = this.props;

    return <React.Fragment>
      <div style={{ paddingLeft: 20 }}>
        {additionalServices && additionalServices.length > 0 && <List
          itemLayout="horizontal"
          dataSource={additionalServices}
          renderItem={item=><li style={{padding:'12px 0'}}><CheckboxServiceItem onChange={this.onCheckboxChange} checked={this.hasOption(item.name)} item={item}/></li>}
        />
        }

        {extraServices && extraServices.length > 0 && <List
          itemLayout="horizontal"
          dataSource={extraServices}
          renderItem={item=><li style={{padding:'12px 0'}}><CheckboxServiceItem onChange={this.onCheckboxChange} checked={this.hasOption(item.name)} item={item}/></li>}
        />
        }
      </div>
    </React.Fragment>
  }
}


const mapDispatchToProps = dispatch => ({
  addService: params => dispatch({ type: 'SAVE.ADD_SERVICE', params }),
  removeService: params => dispatch({ type: 'SAVE.REMOVE_SERVICE', params }),
});

const mapStateToProps = state => ({
  selectedOptions: state.createAppointmentRequest.selectedOptions,
  additionalServices: state.customerPreJourneyInfo.preJourneyInfo && state.customerPreJourneyInfo.preJourneyInfo.services && state.customerPreJourneyInfo.preJourneyInfo.services.additionalServices,
  extraServices: state.customerPreJourneyInfo.preJourneyInfo && state.customerPreJourneyInfo.preJourneyInfo.services && state.customerPreJourneyInfo.preJourneyInfo.services.extraServices,
});

export default injectIntl(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(AdditionalServices)
);



// WEBPACK FOOTER //
// ./src/public/journey1/fragments/services/AdditionalServices.js